import { Building2, Mail, Globe, Briefcase } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const OnboardingStepCompany = ({ companyInfo, setCompanyInfo }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-2 mb-4">
      <Building2 className="h-5 w-5 text-[#7B1F2A]" />
      <h3 className="text-lg font-semibold">Company Information</h3>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <Label>Company Name *</Label>
        <Input
          value={companyInfo.company_name}
          onChange={(e) => setCompanyInfo({ ...companyInfo, company_name: e.target.value })}
          placeholder="Acme Corporation"
          data-testid="onboard-company-name"
        />
      </div>
      <div>
        <Label>Company Email</Label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            type="email"
            value={companyInfo.company_email}
            onChange={(e) => setCompanyInfo({ ...companyInfo, company_email: e.target.value })}
            placeholder="info@company.com"
            className="pl-10"
          />
        </div>
      </div>
      <div>
        <Label>Website</Label>
        <div className="relative">
          <Globe className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            value={companyInfo.website}
            onChange={(e) => setCompanyInfo({ ...companyInfo, website: e.target.value })}
            placeholder="https://www.company.com"
            className="pl-10"
          />
        </div>
      </div>
      <div className="md:col-span-2">
        <Label>Industry</Label>
        <div className="relative">
          <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            value={companyInfo.industry}
            onChange={(e) => setCompanyInfo({ ...companyInfo, industry: e.target.value })}
            placeholder="Technology, Healthcare, Finance, etc."
            className="pl-10"
          />
        </div>
      </div>
    </div>
  </div>
);
